import React from 'react';
import * as _ from 'lodash';
import { RiskFactoryPipe } from '../../../../shared/pipes/RiskFactorPipe';
import {
    isValidRatio,
    RiskCategory,
    RiskCategoryLabel
} from '../simulation.model';

/* The share of the score of a category that a factor has with the ratios that are typed in, for the factors with a valid one. */
export const getRatioShares = (factors, typed) => {
    const ratios = _.map(factors, factor => {
        const raw = _.get(typed, factor.riskFactorKey);
        return _.isNil(raw)
            ? factor.riskFactorWeight
            : isValidRatio(raw)
            ? Number(_.trim(raw))
            : 0;
    });
    const total = _.sum(ratios);

    return _.zipObject(
        _.map(factors, 'riskFactorKey'),
        _.map(ratios, ratio => (total ? Math.round((ratio / total) * 100) : 0))
    );
};

/*
  The risk factors of the sandbox with their ratios, to change the ones to try. The weights of the factors follow from the ratios:
  the share of each is its ratio out of the total of the category.
*/
export const RiskRatioEditor = ({ risk, edits, onChange }) => {
    const categories = _.filter(
        _.values(RiskCategory),
        category => !_.isEmpty(risk[category])
    );

    if (_.isEmpty(categories)) {
        return (
            <span className={'sim-muted'}>
                The sandbox has no risk configuration.
            </span>
        );
    }

    return (
        <div className={'sim-risk-editor'}>
            {categories.map(category => {
                const factors = _.sortBy(risk[category], 'riskFactorKey');
                const shares = getRatioShares(factors, edits[category]);

                return (
                    <div key={category}>
                        <div className={'sim-category-title'}>
                            {RiskCategoryLabel[category]}
                        </div>
                        <div className={'table'}>
                            <table>
                                <tbody>
                                    <tr className="headers">
                                        <th>Risk factor</th>
                                        <th>Ratio (0 - 100)</th>
                                        <th className={'align-right'}>
                                            Share of the score
                                        </th>
                                    </tr>
                                    {factors.map(factor => {
                                        const key = factor.riskFactorKey;
                                        const typed = _.get(edits, [
                                            category,
                                            key
                                        ]);
                                        const value = _.isNil(typed)
                                            ? String(factor.riskFactorWeight)
                                            : typed;
                                        const invalid = !isValidRatio(value);

                                        return (
                                            <tr key={key} className="data">
                                                <td>
                                                    {factor.riskFactorDisplay ||
                                                        RiskFactoryPipe(key)}
                                                </td>
                                                <td className={'sim-form'}>
                                                    <input
                                                        type={'text'}
                                                        style={{ width: 80 }}
                                                        className={
                                                            invalid
                                                                ? 'invalid'
                                                                : ''
                                                        }
                                                        value={value}
                                                        onChange={event =>
                                                            onChange(
                                                                category,
                                                                key,
                                                                event.target
                                                                    .value
                                                            )
                                                        }
                                                    />
                                                </td>
                                                <td className={'align-right'}>
                                                    {shares[key]}%
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
